import { contentfulRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show(slug, withDraft) {
    const url = contentfulRoutes.templateGroup(slug);
    const headers = { Accept: "application/vnd.api+json" };
    const params = {};
    if (withDraft && withDraft === "true") params.filter = { "with-draft": true };
    return FetchHelpers.get(url, params, headers);
  },
};
